import React from 'react'
import { noop } from 'lodash-es'
import { AuditDetail, DealDetail } from 'api'
import { AxeTradeConditionButtons } from 'view/shared/entity'
import { GridAxeTradeConditionButtonsProps } from 'view/components/datagrid/renderers/AxeTradeConditionRenderer'

interface DealAxeTradeConditionButtonsProps extends GridAxeTradeConditionButtonsProps<DealDetail | AuditDetail> {}

export const GridAxeTradeConditionButtons: React.FunctionComponent<DealAxeTradeConditionButtonsProps> = props => {
  const { data } = props

  return (
    <AxeTradeConditionButtons
      isAxed={data.axeTradeCondition.isAxed}
      tradeConditionFlag={data.axeTradeCondition.tradeCondition}
      readOnly={true}
      onUpdate={noop}
    />
  )
}
